export default function IconUser() {
  return (
    <svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 25C22 23.1364 22 22.2047 21.7643 21.4459C21.2537 19.7421 19.9445 18.411 18.2687 17.8918C17.5224 17.6522 16.606 17.6522 14.7731 17.6522H8.22693C6.39401 17.6522 5.47756 17.6522 4.7313 17.8785C3.05549 18.3844 1.74626 19.7155 1.23566 21.4193C1 22.1647 1 23.0965 1 24.9601M17.3653 6.99002C17.3653 10.2912 14.7207 12.98 11.4738 12.98C8.21384 12.98 5.58229 10.2912 5.58229 6.99002C5.58229 3.67554 8.21384 1 11.4738 1C14.7207 1 17.3653 3.67554 17.3653 6.99002Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
